module.exports = __webpack_public_path__ + "img/32.e57da76b.jpg";